import {NgModule} from "@angular/core";
import {GameComponent} from "./game/game.component";
import {LevelsComponent} from "./levels";
import {LcdComponent} from "./lcd/lcd.component";
import {GameBodyDirective} from "./game/game-body";
import {GengineClientComponent, GengineClientService} from "./gengine-client";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatInputModule} from "@angular/material/input";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {CommonModule} from "@angular/common";
import { ChatComponent, MessageLineComponent, ComposeComponent } from './gengine-client/chat';
import {MatDialogModule} from '@angular/material/dialog'
import {GameInput} from "./game/game-input.service";
import {GameSize} from "./game/game-size.service";
import {GameCredits} from "./game/game-credits.service";

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    FormsModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    ReactiveFormsModule,
  ],
  declarations: [
    LcdComponent,
    LevelsComponent,
    GameComponent,
    GameBodyDirective,
    GengineClientComponent,
    ChatComponent,
    MessageLineComponent,
    ComposeComponent,
  ],
  exports: [
    CommonModule,
    LcdComponent,
    LevelsComponent,
    GameBodyDirective,
    GengineClientComponent,
    GameComponent,
    ChatComponent,
    FormsModule,
    MatCheckboxModule,
    MatButtonModule,
  ],
  providers: [
    GengineClientService,
    GameSize,
    GameInput,
    GameCredits,
  ],
  bootstrap: []
})
export class VerlibaSharedModule { }
